import { cn } from '../lib/utils.js';

interface SkeletonProps {
  className?: string;
}

/**
 * Loading-state placeholder. Always rendered with `aria-hidden` — pair with a
 * separate live region (or `aria-busy` on the container) to announce loading
 * to assistive tech.
 */
export function Skeleton({ className }: SkeletonProps): JSX.Element {
  return (
    <div
      className={cn(
        'animate-pulse rounded-xs bg-surface-2',
        className
      )}
      aria-hidden="true"
    />
  );
}

export function SkeletonRows({
  rows = 3,
  cols = 4,
}: {
  rows?: number;
  cols?: number;
}): JSX.Element {
  return (
    <div className="space-y-element p-component">
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex gap-3">
          {Array.from({ length: cols }).map((__, c) => (
            <Skeleton key={c} className="h-4 flex-1" />
          ))}
        </div>
      ))}
    </div>
  );
}
